import { RecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useAxiosWrapper } from '../services/axiosWrapper';
import { authAtom } from './usuarios/AuthState';
import { history } from '../helpers/history';
import { useTranslation } from '../commons/useTranslasion';

function useBaseActions(
  recurso: string,
  state: RecoilState<any>,
  isIndex: boolean = false
) {
  const authState = useRecoilValue(authAtom);
  const baseUrl = isIndex
    ? `${process.env.REACT_APP_API_URL}/v1/empresas`
    : `${process.env.REACT_APP_API_URL}/v1/empresas/${authState?.id}/${recurso}`;
  const axiosWrapper = useAxiosWrapper();
  const setState = useSetRecoilState(state);
  const setAuth = useSetRecoilState(authAtom);
  const { translate } = useTranslation();

  return {
    list: list,
    get: get,
    update: update,
    create: create,
    delete: deleteObj,
    createFormData: createFormData,
    patch: patch,
  };

  async function list(salvarNoState: boolean = false, query: string = '') {
    let url = baseUrl;
    if (query !== '') url += query;

    try {
      const recursos = await axiosWrapper.get(url);
      if (salvarNoState) setState(recursos);
      return recursos;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }

  }

  async function get(id: number) {
    try {
      const recurso = await axiosWrapper.get(`${baseUrl}/${id}`);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  async function update(id: number, obj: object) {
    try {
      const recurso = await axiosWrapper.put(`${baseUrl}/${id}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  async function create(obj: object) {
    try {
      const recurso = await axiosWrapper.post(`${baseUrl}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  async function deleteObj(id: number) {
    try {
      const recurso = await axiosWrapper.delete(`${baseUrl}/${id}`);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  async function createFormData(obj: object) {
    try {
      const recurso = await axiosWrapper.postFormData(`${baseUrl}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  async function patch(id: number, obj: object) {
    try {
      const recurso = await axiosWrapper.patch(`${baseUrl}/${id}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }
}

export { useBaseActions };
